/* Component to render a "cl-header" -- as commonly seen in Controls, with primary and contrast-colored text */

export class ClHeaderComponent implements angular.IComponentOptions {
    public bindings: any = {};
    public controller = ClHeaderController;

    // tslint:disable: max-line-length
    public template: string = `
        <header class="cl-header">
            <span md-colors="{ color: '{{$root.currentTheme.name}}-accent'}" ng-transclude="primary"></span><span class="force-space" ng-transclude="contrast"></span>
        </header>
    `;
    // tslint:enable: max-line-length

    public transclude: any = {
        contrast: '?clHeaderContrast',
        primary: '?clHeaderPrimary'
    };
}

// tslint:disable-next-line: max-classes-per-file
export class ClHeaderController implements angular.IComponentController {
}
